import React, { createContext, useContext, useState, useEffect } from "react";
import {
  getAllInvoice,
  getAllPaymentMethods,
  getAllPlans,
  getCurrentPlan,
  getNextBilling,
} from "../services/billing";

const UpgradContext = createContext();

export const UpgradProvider = ({ children }) => {
  const [data, setData] = useState({
    plans: [],
  });

  const [loading, setLoading] = useState({
    plans: true,
  });

  const [error, setError] = useState({
    plans: null,
  });

const fetchBillingData = async () => {
  try {
    const [plansRes, currentPlanRes] = await Promise.all([
      getAllPlans(),
      getCurrentPlan(),
    ]);

    setData((prev) => ({
      ...prev,
      plans: plansRes?.data?.data || prev.plans,
      currentPlan: currentPlanRes?.data?.data || null,
    }));

    setError((prev) => ({
      ...prev,
      plans: null,
      currentPlan: null,
    }));
  } catch (error) {
    setError((prev) => ({
      ...prev,
      plans: error?.message || "Failed to load plans",
      currentPlan: error?.message || "Failed to load current plan",
    }));
  } finally {
    setLoading((prev) => ({
      ...prev,
      plans: false,
      currentPlan: false,
    }));
  }
};


  useEffect(() => {
    fetchBillingData();
  }, []);

  return (
    <UpgradContext.Provider
      value={{
        ...data,
        loading,
        error,
        refetchBilling: fetchBillingData,
      }}
    >
      {children}
    </UpgradContext.Provider>
  );
};

export const useUpgrad = () => useContext(UpgradContext);